/** List of known extension keys on the CustomFieldChoice */ export var CustomFieldChoiceExtensionKeys = /*#__PURE__*/ function(CustomFieldChoiceExtensionKeys) {
    /** The extension key for the color data (backgroundColor and foregroundColor) */ CustomFieldChoiceExtensionKeys["colorData"] = "colorData";
    /** The extension key for the order hint (ordering string for the choice) */ CustomFieldChoiceExtensionKeys["orderHint"] = "orderHint";
    return CustomFieldChoiceExtensionKeys;
}({});
